var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricIconFinished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16953_388)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5.81818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.746094,
    width: 30.5,
    height: 30.5,
    rx: 5.06818,
    stroke: "#7064B7",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16953_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 15.9961L24.9961 6.99609",
    stroke: "#7064B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3597 9.63233C20.7656 8.04198 18.6327 7.10786 16.3828 7.01477C14.133 6.92168 11.9302 7.67641 10.2101 9.12965C8.49007 10.5829 7.37811 12.6288 7.09421 14.8626C6.81032 17.0964 7.37517 19.3554 8.67701 21.1926C9.97886 23.0299 11.9229 24.3117 14.1245 24.7843C16.3261 25.257 18.6249 24.8861 20.5661 23.7451C22.5074 22.604 23.9497 20.7759 24.6077 18.6224C25.2657 16.469 25.0914 14.1469 24.1194 12.1158",
    stroke: "#7064B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1781 12.8141C18.4337 12.0706 17.4523 11.6115 16.4045 11.5164C15.3567 11.4214 14.3087 11.6965 13.4427 12.294C12.5767 12.8914 11.9474 13.7734 11.6642 14.7867C11.3809 15.7999 11.4617 16.8804 11.8924 17.8403C12.3232 18.8002 13.0766 19.5788 14.0218 20.0409C14.967 20.5029 16.0443 20.6192 17.0663 20.3694C18.0883 20.1197 18.9905 19.5197 19.6161 18.6738C20.2417 17.8279 20.5511 16.7895 20.4906 15.7391",
    stroke: "#7064B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.296094,
    y: 0.296094,
    width: 31.4,
    height: 31.4,
    rx: 4.7,
    stroke: "#7064B7",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16953_388"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16953_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3.99609 3.99609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconFinished);
export default __webpack_public_path__ + "static/media/MetricIconFinished.bc34cdbf675344d469b12e900fb16fd5.svg";
export { ForwardRef as ReactComponent };